import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import "./WelocateEnergyLabelFilter.css";

const ENERGY_LABELS = ["A+++", "A++", "A+", "A", "B", "C", "D", "E", "F", "G"];

const WelocateEnergyLabelFilter = ({ selected, onToggle }) => (
  <div className="wl-energy-filter">
    {ENERGY_LABELS.map((value) => {
      const isSelected = selected.includes(value);
      return (
        <button
          key={value}
          className={`wl-energy-filter__option${isSelected ? " wl-energy-filter__option--selected" : ""}`}
          onClick={() => onToggle(value)}
        >
          <span style={{ flex: 1 }}>{`Label ${value}`}</span>
          {isSelected && <CheckIcon className="wl-energy-filter__check" />}
        </button>
      );
    })}
  </div>
);

export default WelocateEnergyLabelFilter;
